export const SITE_CONFIG = {
  brandName: 'Doña Blanca',
  tagline: 'Sabor todos los días. Operación a gran escala.',
  facturacionUrl: '/facturacion',
  whatsappUrl: 'https://wa.me/525500000000?text=Hola%2C%20quiero%20informaci%C3%B3n%20sobre%20servicios%20de%20alimentaci%C3%B3n%20para%20empresas',
  rappiDefaultUrl: 'https://www.rappi.com.mx/restaurantes/1930440050-dona-blanca',
  officialSiteUrl: 'https://www.fondadonablanca.com',
  privacyPolicyUrl: 'https://www.fondadonablanca.com/aviso-de-privacidad',
  instagramUrl: 'https://www.instagram.com/donablancamexico/',
  facebookUrl: 'https://www.facebook.com/p/Do%C3%B1a-Blanca-Restaurante-100063550645209/',
  linkedinUrl: 'https://www.linkedin.com',
  youtubeUrl: 'https://www.youtube.com',
  city: 'Ciudad de México, México',
  copyright: '© 2026 Doña Blanca. Todos los derechos reservados. "Doña Blanca" es una marca registrada de A+A Servicios.',
};
